import { render, staticRenderFns } from "./chooseMenuGroup.vue?vue&type=template&id=33344c38&scoped=true"
import script from "./chooseMenuGroup.vue?vue&type=script&lang=js"
export * from "./chooseMenuGroup.vue?vue&type=script&lang=js"
import style0 from "./chooseMenuGroup.vue?vue&type=style&index=0&id=33344c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33344c38",
  null
  
)

export default component.exports